import React from 'react';
import { FileViewerModal } from '../common';
import { FileSerializableItem } from '@/interface';

interface ReportViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  report_url: string;
  case_id: number;
  report_urn?: string;
  showDownload?: boolean;
}
export const ReportViewerModal: React.FC<ReportViewerModalProps> = props => {
  const {isOpen, onClose, report_url, report_urn, case_id, showDownload = false} =
    props;
  const file: FileSerializableItem = {
    id: case_id,
    name: 'Second Opinion Report.pdf',
    url: report_url,
    size: 0,
  };
  return (
    <FileViewerModal
      key={report_urn || case_id.toString()}
      isOpen={isOpen}
      onClose={onClose}
      file={file}
      showDownloadButton={showDownload}
      is_second_opinion_report
      isSecure
    />
  );
};